export default class Locomotive {
    public name = ''
    public type = ''
    public stationFrom = ''
    public stationTo = ''
    public trainNumber = ''
    public trainWeight = ''
    public controllerPosition = ''
    public mileage = ''
    public lastPosition = ''
}
